import axios from 'axios';
import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import { trackPage } from '../../lib/analytics-helper';
import Page from '../../lib/page';

const requestRACELigibility = () => ({ type: types.REQUEST_RAC_ELIGIBILITY });

const receiveRACELigibilityError = () => ({ type: types.RECEIVE_RAC_ELIGIBILITY_ERROR });

const receiveRACELigibility = payload => ({ type: types.RECEIVE_RAC_ELIGIBILITY, payload });

const requestRACSubmit = payload => ({ type: types.REQUEST_RAC_SUBMIT, payload });

const receiveRACSubmitFail = payload => ({ type: types.REQUEST_RAC_SUBMIT_FAIL, payload });

const receiveRACSubmitError = () => ({ type: types.RECEIVE_RAC_SUBMIT_ERROR });

const receiveRACSubmit = payload => ({ type: types.RECEIVE_RAC_SUBMIT, payload });

const makeRACInEligibility = () => ({ type: types.MAKE_RAC_INELIGIBLE });

// -- LOCAL ACTIONS --
const showPopUp = () => ({ type: types.RAC_SHOWPOPUP });

const hidePopUp = () => ({ type: types.RAC_HIDEPOPUP });

const getNewNum = () => ({ type: types.RAC_GET_NEWNUM });

const getPrimaryNum = () => ({ type: types.RAC_GET_PRIMARY });

const getRACEligibility = () => (dispatch, getState) => {
  dispatch(requestRACELigibility());
  // if IDI enabled get segment from IDI state else nothing
  const segName = (((((((getState().contactChannels || {}).OriginalRiskResponse || []).filter(obj => (obj.name === 'RAC')) || [])[0] || {}).additional_data || [])
    .filter(obj => (obj.key === 'queue_id')) || [])[0] || {}).value || null;
  const segNameLoLi = _get(getState(), 'smcResultKeeper.topicTreeSelectResult.topicRefId');
  if (Page.isIDIenableForRAC() && !(segName || segNameLoLi)) {
    return dispatch(makeRACInEligibility());
  }
  // if IDI is true & segment is available
  const idiEnable = (Page.isIDIenableForRAC() && !!segName) ? `?segment=${segName || segNameLoLi}` : '';
  const racURL = `/smarthelp/rac-eligibility${idiEnable}`;
  return axios.get(racURL)
    .then((response) => {
      const racInfo = ((response || {}).data || {}).racInfo;
      dispatch(receiveRACELigibility(racInfo));
    })
    .catch(() => {
      dispatch(receiveRACELigibilityError());
    });
};

function deformatPhoneNumber(s) {
  return (`${s}`).replace(/\D/g, '');
}

const doRACSubmit = (code, phoneNumber, segmentName) => (dispatch) => {
  dispatch(requestRACSubmit({ code, num: deformatPhoneNumber(phoneNumber) }));
  const racSubmitURL = '/smarthelp/rac-submit';

  return axios.post(racSubmitURL, { phoneNumber: deformatPhoneNumber(phoneNumber), segment_name: segmentName, _csrf: document.body.getAttribute('data-token') })
    .then((response) => {
      const racData = ((response || {}).data || {}).racInfo;
      if (racData.success) {
        // Success case
        dispatch(receiveRACSubmit(racData));
      } else {
        // Failure case
        trackPage({ id: 'requestACallError', link: 'racFailureAlert' });
        dispatch(receiveRACSubmitFail(racData));
      }
    })
    .catch(() => {
      dispatch(receiveRACSubmitError());
    });
};

module.exports = {
  getRACEligibility,
  showPopUp,
  hidePopUp,
  getNewNum,
  getPrimaryNum,
  doRACSubmit,
  deformatPhoneNumber,
};

